import serializeError from "serialize-error";

export default function(error) {
  const { stack, ...formatted } = serializeError(error);

  if (process.env.NODE_ENV === "development") {
    return { stack, ...formatted };
  }

  return formatted;
}
